import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { TooltipDirective } from "./tooltip.directive";

const DIRECTIVES = [TooltipDirective];

@NgModule({
	imports: [CommonModule, MatMenuModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class TooltipDirectiveModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
